<template>
    <b-jumbotron v-if="loaded">
        <h2>{{ form.title }}</h2>
        <fieldset
            :disabled="disabled || working"
        >
            <template
                v-for="(field, idx) in form.fields"
            >
                <form-group
                    v-if="field.type == 'group'"
                    v-bind:key="idx"
                    :group="field"
                    v-model="field.object"
                ></form-group>
                <b-card
                    v-else
                    v-bind:key="idx"
                    class="mb-2"
                    :sub-title="field.label"
                >
                    <b-form-group>
                        <form-field
                            :field="field"
                            v-model="field.value"
                        ></form-field>
                    </b-form-group>
                </b-card>
            </template>
            <div class="mt-4 text-center">
                <slot
                    name="button"
                    :saveStudent="save"
                    :btnDisabled="btnDisabled"
                >
                    <button
                        v-if="form.submitBtnText"
                        :disabled="disabled"
                        @click="save()"
                        class="sc-btn sc-btn-lg pill"
                    >
                        {{ form.submitBtnText }}
                    </button>
                </slot>
            </div>
            <b-collapse v-show="false">
                <pre>{{ defaultValues }}</pre>
                <pre>{{ form }}</pre>
                <pre>{{ input }}</pre>
                <!--<pre>{{ form }}</pre>-->
                <button @click="input = mapFormData(form)">Update</button>
            </b-collapse>
        </fieldset>
    </b-jumbotron>
    <b-jumbotron
        v-else-if="loading"
        class="text-center"
    >
        <b-spinner label="Loading..."></b-spinner>
    </b-jumbotron>
    <b-jumbotron
        v-else-if="!loaded"
        class="text-center"
    >
        <h4>Error loading form.</h4>
        <em>This form does not exist.</em>
    </b-jumbotron>
</template>
<script>
import FormGroup from "./FormGroup"
import FormField from "./FormField"
//import { datetime } from 'vue-datetime'; <!--<datetime v-model="date"></datetime>-->

export default {
    name        :   "app-form",
    props       :   [
                        "disabled",
                        "defaultValues",
                        "formKey"
                    ],
    mounted     ()  {
                        this.loadForm();
                    },
    data        ()  {
                        return  {
                                    loaded          :   false,
                                    loading         :   false,
                                    working         :   false,
                                    input           :   {},
                                    form            :   {}
                                };
                    },
    computed    :   {
                        changeInput (value) {
                                                console.log(value);
                                            },
                        btnDisabled ()      {
                                                //var disabled = !(this.firstNameState && this.lastNameState);
                                                return this.working; // || disabled;
                                            },
                                            /*(this.first_name.length && this.first_name.length <= 20) ? true : false;*/
    },
    methods     :   {
                        mapFormData(root)
                                {
                                    if (!root.fields) return;
                                    var data = {};
                                    root.fields.forEach((field) => {
                                        if (field.type == "group") {
                                            data[field.key] = {
                                                ...(data[field.key] || {}),
                                                ...this.mapFormData(field)
                                            };
                                        } else {
                                            data[field.name] = field.value;
                                        }
                                    });
                                    return data;
                                },
                        setDefaultValues (parent, defaultValues)
                                {
                                    parent.fields.forEach((field) => {
                                        if (field.type == "group") {
                                            this.setDefaultValues(field, defaultValues[field.key]);
                                        } else if (typeof defaultValues != "undefined") {
                                            field.value = defaultValues[field.name];
                                        }
                                    });
                                },
                        loadForm () 
                                {
                                    this.loaded  = false;
                                    this.loading = true;
                                    this.$api.get(
                                        "/api/getFormSchema?formKey=" + this.formKey
                                    ).then((request) => {
                                        var data = request.data;
                                        if (data.fetched) {
                                            this.form = JSON.parse(data.form.FormSchema);
                                            if (typeof this.defaultValues != "undefined") {
                                                this.setDefaultValues(this.form, this.defaultValues);
                                            }
                                            this.loaded  = true;
                                            this.$emit("loaded", this.form);
                                        } else {
                                            this.loaded = false;
                                        }
                                        this.loading = false;
                                    });
                                },
                        textValid(text, name, max, min)
                                {
                                    if (text.length > max) {
                                        return name + " is too long!";
                                    } else if (text.length > min) {
                                        return name + " is too short!"
                                    }
                                    return "";
                                },
                        changeValid (date_valid, date)
                                {
                                    if (date_valid && date.length == 10) this.changeDisabled(); 
                                },
                        changeDisabled ()
                                {
                                    //var disabled = !(this.firstNameState && this.lastNameState);
                                    this.$emit("disabled", disabled);
                                },
                        mergeObjects(obj1, obj2)
                                {
                                    var newObj = {};
                                    function isObject(value) {
                                        return (typeof value == "object" && value != null);
                                    }
                                    (new Set(
                                                Object.keys(obj1).concat(Object.keys(obj2))
                                            )).forEach((_, key, set) => {
                                                    console.log(key, set);
                                                    const val1 = obj1[key];
                                                    const val2 = obj2[key];
                                                    if  (
                                                            isObject(val1) &&
                                                            isObject(val2)
                                                        ) {
                                                            newObj[key] = this.mergeObjects(val1, val2);
                                                    } else if (typeof val2 != "undefined") {
                                                        newObj[key] = val2;
                                                    } else if (typeof val1 != "undefined") {
                                                        newObj[key] = val1;
                                                    }
                                                });
                                    return newObj;
                                },
                        save ()
                                {
                                    this.$emit("disabled", true);
                                    //console.log("key", this.input.student, JSON.stringify(this.input.personal_info) );
                                    this.working = true;
                                    console.log(this.mergeObjects   (
                                                                (this.defaultValues || {}),
                                                                this.mapFormData(this.form)
                                                            ));
                                    this.$api.post(
                                        this.form.url,
                                        this.mergeObjects   (
                                                                (this.defaultValues || {}),
                                                                this.mapFormData(this.form)
                                                            )
                                    ).then((request) => {
                                        var data = request.data;
                                        if (!data.submitted) {
                                            this.$bvToast.toast(data.error.message, {
                                                title           :   data.error.title,
                                                autoHideDelay   :   5000,
                                                appendToast     :   true
                                            });
                                        } else {
                                            //this.$store.commit("newStudent", data.model);
                                            this.$bvToast.toast(data.success.message, {
                                                title           :   data.success.title,
                                                autoHideDelay   :   5000,
                                                appendToast     :   true
                                            });
                                            this.$emit("submitted", data);
                                            this.$emit("close");
                                        }
                                        this.working = false;
                                    });
                                }
                    },
    components  :   {
                        FormGroup,
                        FormField
                    }
}
</script>